import { useContext, useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Alert,
} from "@mui/material";
import styles from "./Award.module.scss";
import { ButtonLoader } from "../../../../elements/CustomLoader/Loader";
import ScreenLoader from "../../../../elements/CustomScreeenLoader/ScreenLoader";
import AwardPopUp from "../../../../elements/CustomModal/AwardPopUp ";
import cn from "classnames";
import _sendAPIRequest from "../../../../helpers/api";
import { PortalApiUrls } from "../../../../helpers/api-urls/PortalApiUrls";
import { AlertContext } from "../../../../contexts/AlertProvider";
import DeleteDialog from "../../../../elements/CustomDialog/DeleteDialog";
const Analysis = ({ bidDetails }) => {
  const [selectedSupplierMap, setSelectedSupplierMap] = useState({});
  const [screenLoader, setScreenLoader] = useState(true);
  const [open, setOpen] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(false);
  const [bidders, setBidders] = useState([]);
  const [supplierName, setSupplierName] = useState();
  const [awardStatus, setAwardStatus] = useState(null);
  const { setAlert } = useContext(AlertContext);

  const [deleteDetails, setDeleteDetails] = useState({
    open: false,
    title: "",
    message: "",
    alertmessage: "",
    id: null,
    handleAction: "",
  });

  const handleChange = (event, supplierId, productId) => {
    setSupplierName(event.target.value);

    setSelectedSupplierMap({
      [productId]: supplierId,
    });
  };

  const handleCencelProduct = (choice) => {
    if (choice) {
      cencelProduct(deleteDetails?.id, deleteDetails.alertmessage);
    } else {
      setDeleteDetails({
        open: false,
        title: "",
        message: "",
        alertmessage: "",
        id: null,
      });
    }
  };

  const handleProductAward = (choice) => {
    if (choice) {
      awardSupplier(deleteDetails.supplierId);
      setExpandedIndex(false);
    } else {
      setDeleteDetails({
        open: false,
        title: "",
        message: "",
        alertmessage: "",
        id: null,
      });
    }
  };

  const handleClose = () => setOpen(false);

  const fetchSupplierForAward = async () => {
    try {
      const response = await _sendAPIRequest(
        "GET",
        PortalApiUrls.LIVE_BID_PRODUCT_FOR_AWARD + `${bidDetails?.id}/`,
        "",
        true
      );
      if (response.status === 200) {
        console.log(response.data, " : awarded");
        setBidders(response.data);
        setScreenLoader(false);
      }
    } catch (error) {}
  };

  const awardSupplier = async (supplierId) => {
    if (!supplierId) {
      setAlert({
        isVisible: true,
        message: "Please select a supplier",
        severity: "error",
      });
      return;
    }

    try {
      const response = await _sendAPIRequest(
        "PUT",
        PortalApiUrls.LIVE_BID_AWARD_BUYER + `${supplierId}/`,
        "",
        true
      );

      if (response) {
        setDeleteDetails({ open: false });
        setOpen(true);
        setAwardStatus(response.status);
      }
    } catch (error) {}
  };

  const cencelProduct = async (productId) => {
    try {
      const response = await _sendAPIRequest(
        "DELETE",
        PortalApiUrls.LIVE_BID_CENCEL_PRODUCT + `${productId}/`,
        "",
        true
      );
      if (response.status === 204) {
        setDeleteDetails({ open: false });
        setAlert({
          isVisible: true,
          message: `Product Cancelled`,
          severity: "success",
        });
        setAwardStatus(response.status);
      }
    } catch (error) {
      setAlert({
        isVisible: true,
        message: `${error.message}`,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    fetchSupplierForAward();
  }, [awardStatus, deleteDetails.open]);

  if (screenLoader) {
    return <ScreenLoader />;
  }

  const isNonL1 = bidders.some((bidder) => {
    if (!bidder?.participant?.length) return false;
    const supplier = bidder.participant.find((s) => s.company === supplierName);
    if (!supplier) return false;
    return supplier.position !== 1;
  });

  return (
    <>
      <br />
      <div className={styles["heading"]}>
        <Typography variant="h6">Product Name</Typography>
      </div>
      <Alert severity="warning" className="my-3">
        <p style={{ margin: 0 }}>
          <strong>Note:</strong> Products that are not awarded within 7 days
          will be automatically cancelled.
        </p>
      </Alert>
      {bidders.map((awardBidder, index) => {
        {
          console.log(awardBidder?.participant?.length === 0, " : bidders");
        }

        return (
          <Accordion
            key={index}
            expanded={true} // ✅ sab hamesha open
            sx={{
              margin: "16px 0",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%"
                }}>
                {/* LEFT: Product name + Pending badge */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                  }}>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.05rem",
                      color: "#052c65",
                    }}
                  >
                    {awardBidder?.product}
                  </Typography>

                  {awardBidder?.award_status === "pending" && (
                    <span className={styles["pending-badge"]}>Pending</span>
                  )}
                </Box>

                {awardBidder?.award_status === "pending" ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2
                    }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={(event) => {
                        event.stopPropagation();
                        setDeleteDetails({
                          open: true,
                          title: "Cancel Product Confirmation",
                          message: `Are you sure you want to cancel ${awardBidder?.product} Product? This action cannot be undone.`,
                          alertmessage: `${awardBidder?.product} Cancelled Successfully`,
                          id: awardBidder?.id,
                          handleAction: "cancelProduct",
                        });
                      }}
                      className={cn("btn", "button", "reject")}
                    >
                      Cancel Product
                    </Button>
                    {console.log(awardBidder)}
                    {awardBidder?.participant?.length !== 0 && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={(event) => {
                          event.stopPropagation();

                          const selectedSupplier =
                            selectedSupplierMap[awardBidder.id];

                          if (!selectedSupplier) {
                            setAlert({
                              isVisible: true,
                              message: "Please select a supplier",
                              severity: "error",
                            });
                            return;
                          }

                          setDeleteDetails({
                            open: true,
                            title: "Award Supplier",
                            message:
                              "Are you sure you want to award this supplier?",
                            alertmessage: "Product awarded Successfully",
                            id: awardBidder.id,
                            supplierId: selectedSupplier,
                            handleAction: "awardSupplier",
                          });
                        }}
                        className={styles["award-btn"]}
                      >
                        Award Supplier
                      </Button>
                    )}
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      px: 2.2,
                      py: 0.8,
                      borderRadius: "14px",
                      fontSize: "0.75rem",
                      fontWeight: 700, // 👈 more bold
                      letterSpacing: "0.6px", // 👈 crisp text
                      textTransform: "uppercase", // 👈 better badge feel
                      border: "1px solid",
                      backgroundColor:
                        awardBidder?.award_status === "cancelled"
                          ? "#fdecea"
                          : "#e6f4ea",
                      color:
                        awardBidder?.award_status === "cancelled"
                          ? "#b71c1c"
                          : "#1b5e20",
                      borderColor:
                        awardBidder?.award_status === "cancelled"
                          ? "#f5c2c7"
                          : "#b7dfc2",
                      boxShadow:
                        awardBidder?.award_status === "cancelled"
                          ? "0 0 0 1px rgba(183, 28, 28, 0.15)"
                          : "0 0 0 1px rgba(27, 94, 32, 0.15)",
                    }}
                  >
                    {awardBidder?.award_status}
                  </Typography>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              {/* ⚠️ Alert */}
              {(!awardBidder?.participant ||
                awardBidder.participant.length === 0) && (
                <Alert severity="warning" sx={{ mb: 2, borderRadius: "8px" }}>
                  No supplier has participated for this product. Please cancel
                  this product to proceed further.
                </Alert>
              )}
              <TableContainer
                component={Paper}
                sx={{ borderRadius: "8px", overflow: "hidden" }}
              >
                <Table aria-label="suppliers table">
                  <TableHead sx={{ backgroundColor: "#9ec0fa" }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", color: "#052c65" }}>
                        SUPPLIERS NAMES
                      </TableCell>
                      {/* ✨ small fix: centers -> center */}
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", color: "#052c65" }}
                      >
                        BID AMOUNT
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: "bold", color: "#052c65" }}
                      >
                        BID POSITION
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {awardBidder?.participant
                      ?.sort((a, b) => a.amount - b.amount)
                      .map((supplier, i) => (
                        <TableRow
                          key={i}
                          sx={{ "& td": { padding: "12px 16px" } }}
                        >
                          <TableCell>
                            <Radio
                              checked={
                                awardBidder.award_status === "awarded"
                                  ? supplier?.is_awarded === true
                                  : selectedSupplierMap[awardBidder.id] ===
                                    supplier.id
                              }
                              disabled={
                                awardBidder.award_status === "cancelled" ||
                                awardBidder.award_status === "awarded"
                              }
                              onChange={(event) =>
                                handleChange(event, supplier.id, awardBidder.id)
                              }
                              value={supplier.company}
                              name={`supplier-${awardBidder.id}`}
                              sx={{ "&.Mui-checked": { color: "#062d72" } }}
                            />

                            {supplier?.company}
                          </TableCell>
                          <TableCell align="left">
                            ₹ {supplier?.amount}
                          </TableCell>
                          <TableCell align="right">
                            {supplier?.position}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        );
      })}
      <AwardPopUp open={open} handleClose={handleClose} />
      {deleteDetails?.open && (
        <DeleteDialog
          title={deleteDetails.title}
          message={deleteDetails.message}
          handleClick={
            deleteDetails.handleAction === "cancelProduct"
              ? handleCencelProduct
              : handleProductAward
          }
          supplierName={supplierName}
          isNonL1={isNonL1}
        />
      )}
    </>
  );
};

export default Analysis;
